@if (isOpen) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <!-- Modal Content -->
      <app-subscription-comparison
        [showUpgradeButton]="true"
        (upgrade)="onUpgrade()"
      />
    </div>
  </div>
}
